import { render, staticRenderFns } from "./plan-badge.component.vue?vue&type=template&id=7c35101b"
import script from "./plan-badge.component.vue?vue&type=script&lang=js"
export * from "./plan-badge.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports